import { HashRouter } from 'react-router-dom';

interface AppRouterProps {
  children: React.ReactNode;
}

export function AppRouter({ children }: AppRouterProps) {
  return <HashRouter>{children}</HashRouter>;
}
